import { render, staticRenderFns } from "./random-tweet-list.vue?vue&type=template&id=38b2c599&scoped=true&"
import script from "./random-tweet-list.vue?vue&type=script&lang=ts&"
export * from "./random-tweet-list.vue?vue&type=script&lang=ts&"
import style0 from "./random-tweet-list.vue?vue&type=style&index=0&id=38b2c599&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b2c599",
  null
  
)

export default component.exports